export const timeZones = [
  {
    name: '(GMT-11:00) American Samoa',
    value: 'American Samoa',
  },
  {
    name: '(GMT-11:00) International Date Line West',
    value: 'International Date Line West',
  },
  {
    name: '(GMT-11:00) Midway Island',
    value: 'Midway Island',
  },
  {
    name: '(GMT-11:00) Samoa',
    value: 'Samoa',
  },
  {
    name: '(GMT-10:00) Hawaii',
    value: 'Hawaii',
  },
  {
    name: '(GMT-09:00) Alaska',
    value: 'Alaska',
  },
  {
    name: '(GMT-09:00) America/Nome',
    value: 'America/Nome',
  },
  {
    name: '(GMT-08:00) Pacific Time (US & Canada)',
    value: 'Pacific Time (US & Canada)',
  },
  {
    name: '(GMT-08:00) Tijuana',
    value: 'Tijuana',
  },
  {
    name: '(GMT-07:00) Arizona',
    value: 'Arizona',
  },
  {
    name: '(GMT-07:00) Chihuahua',
    value: 'Chihuahua',
  },
  {
    name: '(GMT-07:00) Mazatlan',
    value: 'Mazatlan',
  },
  {
    name: '(GMT-07:00) Mountain Time (US & Canada)',
    value: 'Mountain Time (US & Canada)',
  },
  {
    name: '(GMT-06:00) Central America',
    value: 'Central America',
  },
  {
    name: '(GMT-06:00) Central Time (US & Canada)',
    value: 'Central Time (US & Canada)',
  },
  {
    name: '(GMT-06:00) Guadalajara',
    value: 'Guadalajara',
  },
  {
    name: '(GMT-06:00) Mexico City',
    value: 'Mexico City',
  },
  {
    name: '(GMT-06:00) Monterrey',
    value: 'Monterrey',
  },
  {
    name: '(GMT-06:00) Saskatchewan',
    value: 'Saskatchewan',
  },
  {
    name: '(GMT-05:00) America/New_York',
    value: 'America/New_York',
  },
  {
    name: '(GMT-05:00) Bogota',
    value: 'Bogota',
  },
  {
    name: '(GMT-05:00) Eastern Time (US & Canada)',
    value: 'Eastern Time (US & Canada)',
  },
  {
    name: '(GMT-05:00) Indiana (East)',
    value: 'Indiana (East)',
  },
  {
    name: '(GMT-05:00) Lima',
    value: 'Lima',
  },
  {
    name: '(GMT-05:00) Quito',
    value: 'Quito',
  },
  {
    name: '(GMT-04:30) Caracas',
    value: 'Caracas',
  },
  {
    name: '(GMT-04:00) Atlantic Time (Canada)',
    value: 'Atlantic Time (Canada)',
  },
  {
    name: '(GMT-04:00) Georgetown',
    value: 'Georgetown',
  },
  {
    name: '(GMT-04:00) La Paz',
    value: 'La Paz',
  },
  {
    name: '(GMT-03:30) Newfoundland',
    value: 'Newfoundland',
  },
  {
    name: '(GMT-03:00) Brasilia',
    value: 'Brasilia',
  },
  {
    name: '(GMT-03:00) Buenos Aires',
    value: 'Buenos Aires',
  },
  {
    name: '(GMT-03:00) Greenland',
    value: 'Greenland',
  },
  {
    name: '(GMT-03:00) Montevideo',
    value: 'Montevideo',
  },
  {
    name: '(GMT-03:00) Santiago',
    value: 'Santiago',
  },
  {
    name: '(GMT-02:00) Mid-Atlantic',
    value: 'Mid-Atlantic',
  },
  {
    name: '(GMT-01:00) Azores',
    value: 'Azores',
  },
  {
    name: '(GMT-01:00) Cape Verde Is.',
    value: 'Cape Verde Is.',
  },
  {
    name: '(GMT+00:00) Casablanca',
    value: 'Casablanca',
  },
  {
    name: '(GMT+00:00) Dublin',
    value: 'Dublin',
  },
  {
    name: '(GMT+00:00) Edinburgh',
    value: 'Edinburgh',
  },
  {
    name: '(GMT+00:00) Lisbon',
    value: 'Lisbon',
  },
  {
    name: '(GMT+00:00) London',
    value: 'London',
  },
  {
    name: '(GMT+00:00) Monrovia',
    value: 'Monrovia',
  },
  {
    name: '(GMT+00:00) UTC',
    value: 'UTC',
  },
  {
    name: '(GMT+01:00) Amsterdam',
    value: 'Amsterdam',
  },
  {
    name: '(GMT+01:00) Belgrade',
    value: 'Belgrade',
  },
  {
    name: '(GMT+01:00) Berlin',
    value: 'Berlin',
  },
  {
    name: '(GMT+01:00) Bern',
    value: 'Bern',
  },
  {
    name: '(GMT+01:00) Bratislava',
    value: 'Bratislava',
  },
  {
    name: '(GMT+01:00) Brussels',
    value: 'Brussels',
  },
  {
    name: '(GMT+01:00) Budapest',
    value: 'Budapest',
  },
  {
    name: '(GMT+01:00) Copenhagen',
    value: 'Copenhagen',
  },
  {
    name: '(GMT+01:00) Ljubljana',
    value: 'Ljubljana',
  },
  {
    name: '(GMT+01:00) Madrid',
    value: 'Madrid',
  },
  {
    name: '(GMT+01:00) Paris',
    value: 'Paris',
  },
  {
    name: '(GMT+01:00) Prague',
    value: 'Prague',
  },
  {
    name: '(GMT+01:00) Rome',
    value: 'Rome',
  },
  {
    name: '(GMT+01:00) Sarajevo',
    value: 'Sarajevo',
  },
  {
    name: '(GMT+01:00) Skopje',
    value: 'Skopje',
  },
  {
    name: '(GMT+01:00) Stockholm',
    value: 'Stockholm',
  },
  {
    name: '(GMT+01:00) Vienna',
    value: 'Vienna',
  },
  {
    name: '(GMT+01:00) Warsaw',
    value: 'Warsaw',
  },
  {
    name: '(GMT+01:00) West Central Africa',
    value: 'West Central Africa',
  },
  {
    name: '(GMT+01:00) Zagreb',
    value: 'Zagreb',
  },
  {
    name: '(GMT+02:00) Athens',
    value: 'Athens',
  },
  {
    name: '(GMT+02:00) Bucharest',
    value: 'Bucharest',
  },
  {
    name: '(GMT+02:00) Cairo',
    value: 'Cairo',
  },
  {
    name: '(GMT+02:00) Harare',
    value: 'Harare',
  },
  {
    name: '(GMT+02:00) Helsinki',
    value: 'Helsinki',
  },
  {
    name: '(GMT+02:00) Istanbul',
    value: 'Istanbul',
  },
  {
    name: '(GMT+02:00) Jerusalem',
    value: 'Jerusalem',
  },
  {
    name: '(GMT+02:00) Kaliningrad',
    value: 'Kaliningrad',
  },
  {
    name: '(GMT+02:00) Kyiv',
    value: 'Kyiv',
  },
  {
    name: '(GMT+02:00) Pretoria',
    value: 'Pretoria',
  },
  {
    name: '(GMT+02:00) Riga',
    value: 'Riga',
  },
  {
    name: '(GMT+02:00) Sofia',
    value: 'Sofia',
  },
  {
    name: '(GMT+02:00) Tallinn',
    value: 'Tallinn',
  },
  {
    name: '(GMT+02:00) Vilnius',
    value: 'Vilnius',
  },
  {
    name: '(GMT+03:00) Baghdad',
    value: 'Baghdad',
  },
  {
    name: '(GMT+03:00) Kuwait',
    value: 'Kuwait',
  },
  {
    name: '(GMT+03:00) Minsk',
    value: 'Minsk',
  },
  {
    name: '(GMT+03:00) Moscow',
    value: 'Moscow',
  },
  {
    name: '(GMT+03:00) Nairobi',
    value: 'Nairobi',
  },
  {
    name: '(GMT+03:00) Riyadh',
    value: 'Riyadh',
  },
  {
    name: '(GMT+03:00) St. Petersburg',
    value: 'St. Petersburg',
  },
  {
    name: '(GMT+03:00) Volgograd',
    value: 'Volgograd',
  },
  {
    name: '(GMT+03:30) Tehran',
    value: 'Tehran',
  },
  {
    name: '(GMT+04:00) Abu Dhabi',
    value: 'Abu Dhabi',
  },
  {
    name: '(GMT+04:00) Baku',
    value: 'Baku',
  },
  {
    name: '(GMT+04:00) Muscat',
    value: 'Muscat',
  },
  {
    name: '(GMT+04:00) Samara',
    value: 'Samara',
  },
  {
    name: '(GMT+04:00) Tbilisi',
    value: 'Tbilisi',
  },
  {
    name: '(GMT+04:00) Yerevan',
    value: 'Yerevan',
  },
  {
    name: '(GMT+04:30) Kabul',
    value: 'Kabul',
  },
  {
    name: '(GMT+05:00) Ekaterinburg',
    value: 'Ekaterinburg',
  },
  {
    name: '(GMT+05:00) Islamabad',
    value: 'Islamabad',
  },
  {
    name: '(GMT+05:00) Karachi',
    value: 'Karachi',
  },
  {
    name: '(GMT+05:00) Tashkent',
    value: 'Tashkent',
  },
  {
    name: '(GMT+05:30) Chennai',
    value: 'Chennai',
  },
  {
    name: '(GMT+05:30) Kolkata',
    value: 'Kolkata',
  },
  {
    name: '(GMT+05:30) Mumbai',
    value: 'Mumbai',
  },
  {
    name: '(GMT+05:30) New Delhi',
    value: 'New Delhi',
  },
  {
    name: '(GMT+05:30) Sri Jayawardenepura',
    value: 'Sri Jayawardenepura',
  },
  {
    name: '(GMT+05:45) Kathmandu',
    value: 'Kathmandu',
  },
  {
    name: '(GMT+06:00) Almaty',
    value: 'Almaty',
  },
  {
    name: '(GMT+06:00) Astana',
    value: 'Astana',
  },
  {
    name: '(GMT+06:00) Dhaka',
    value: 'Dhaka',
  },
  {
    name: '(GMT+06:00) Novosibirsk',
    value: 'Novosibirsk',
  },
  {
    name: '(GMT+06:00) Urumqi',
    value: 'Urumqi',
  },
  {
    name: '(GMT+06:30) Rangoon',
    value: 'Rangoon',
  },
  {
    name: '(GMT+07:00) Bangkok',
    value: 'Bangkok',
  },
  {
    name: '(GMT+07:00) Hanoi',
    value: 'Hanoi',
  },
  {
    name: '(GMT+07:00) Jakarta',
    value: 'Jakarta',
  },
  {
    name: '(GMT+07:00) Krasnoyarsk',
    value: 'Krasnoyarsk',
  },
  {
    name: '(GMT+08:00) Beijing',
    value: 'Beijing',
  },
  {
    name: '(GMT+08:00) Chongqing',
    value: 'Chongqing',
  },
  {
    name: '(GMT+08:00) Hong Kong',
    value: 'Hong Kong',
  },
  {
    name: '(GMT+08:00) Irkutsk',
    value: 'Irkutsk',
  },
  {
    name: '(GMT+08:00) Kuala Lumpur',
    value: 'Kuala Lumpur',
  },
  {
    name: '(GMT+08:00) Perth',
    value: 'Perth',
  },
  {
    name: '(GMT+08:00) Singapore',
    value: 'Singapore',
  },
  {
    name: '(GMT+08:00) Taipei',
    value: 'Taipei',
  },
  {
    name: '(GMT+08:00) Ulaanbaatar',
    value: 'Ulaanbaatar',
  },
  {
    name: '(GMT+09:00) Osaka',
    value: 'Osaka',
  },
  {
    name: '(GMT+09:00) Sapporo',
    value: 'Sapporo',
  },
  {
    name: '(GMT+09:00) Seoul',
    value: 'Seoul',
  },
  {
    name: '(GMT+09:00) Tokyo',
    value: 'Tokyo',
  },
  {
    name: '(GMT+09:00) Yakutsk',
    value: 'Yakutsk',
  },
  {
    name: '(GMT+09:30) Adelaide',
    value: 'Adelaide',
  },
  {
    name: '(GMT+09:30) Darwin',
    value: 'Darwin',
  },
  {
    name: '(GMT+10:00) Brisbane',
    value: 'Brisbane',
  },
  {
    name: '(GMT+10:00) Canberra',
    value: 'Canberra',
  },
  {
    name: '(GMT+10:00) Guam',
    value: 'Guam',
  },
  {
    name: '(GMT+10:00) Hobart',
    value: 'Hobart',
  },
  {
    name: '(GMT+10:00) Magadan',
    value: 'Magadan',
  },
  {
    name: '(GMT+10:00) Melbourne',
    value: 'Melbourne',
  },
  {
    name: '(GMT+10:00) Port Moresby',
    value: 'Port Moresby',
  },
  {
    name: '(GMT+10:00) Sydney',
    value: 'Sydney',
  },
  {
    name: '(GMT+10:00) Vladivostok',
    value: 'Vladivostok',
  },
  {
    name: '(GMT+11:00) New Caledonia',
    value: 'New Caledonia',
  },
  {
    name: '(GMT+11:00) Solomon Is.',
    value: 'Solomon Is.',
  },
  {
    name: '(GMT+11:00) Srednekolymsk',
    value: 'Srednekolymsk',
  },
  {
    name: '(GMT+12:00) Auckland',
    value: 'Auckland',
  },
  {
    name: '(GMT+12:00) Fiji',
    value: 'Fiji',
  },
  {
    name: '(GMT+12:00) Kamchatka',
    value: 'Kamchatka',
  },
  {
    name: '(GMT+12:00) Marshall Is.',
    value: 'Marshall Is.',
  },
  {
    name: '(GMT+12:00) Wellington',
    value: 'Wellington',
  },
  {
    name: '(GMT+12:45) Chatham Is.',
    value: 'Chatham Is.',
  },
  {
    name: "(GMT+13:00) Nuku'alofa",
    value: "Nuku'alofa",
  },
  {
    name: '(GMT+13:00) Tokelau Is.',
    value: 'Tokelau Is.',
  },
];
